import { useState } from "react";
import API_CIFRA from "../config/Variables_apis";

export const useGeolocation = () => {
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [address, setAddress] = useState("");
  const [distrito, setDistrito] = useState(null);
  const [ciudad, setCiudad] = useState(null);

  const fetchAddress = async (lat, lng) => {
    const apiKey = "a1100a44b44349b6a3bb16186a5e5a3d";
    const apiUrl = API_CIFRA.openCageGeocode(lat, lng, apiKey);
    try {
      const response = await fetch(apiUrl);
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        const result = data.results[0];
        const formattedAddress = result.formatted;
        setAddress(formattedAddress);
        
        // Extraer distrito y ciudad de la respuesta de OpenCage
        const components = result.components;
        
        // Para Perú: Distrito = subdivision local (Miraflores, San Isidro, etc.)
        const distrito = components.suburb || components.city_district || components.district || components.neighbourhood;
        
        // Para Perú: Ciudad = Provincia/Estado (Lima, Arequipa, etc.)
        // Priorizar state sobre city para evitar duplicación
        let ciudad = components.state;
        
        // Si no hay state, usar city pero verificar que no sea igual al distrito
        if (!ciudad && components.city) {
          ciudad = components.city !== distrito ? components.city : null;
        }
        
        // Si aún no hay ciudad, usar country como fallback
        if (!ciudad) {
          ciudad = components.country;
        }
        
        // Guardar distrito y ciudad en el estado
        setDistrito(distrito ? capitalizeFirst(distrito) : null);
        setCiudad(ciudad ? capitalizeFirst(ciudad) : null);
        
        // Debug: Mostrar todos los componentes disponibles
        console.log('🔍 Componentes OpenCage disponibles:', components);
        console.log('📍 Distrito extraído:', distrito);
        console.log('🏙️ Ciudad extraída:', ciudad);
        console.log('🌍 País:', components.country);
      } else {
        setAddress("Address not found");
        setDistrito(null);
        setCiudad(null);
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      setAddress("Error fetching address");
      setDistrito(null);
      setCiudad(null);
    }
  };

  // Función para capitalizar primera letra
  const capitalizeFirst = (text) => {
    if (!text) return '';
    return text.split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return { 
    latitude, 
    setLatitude, 
    longitude, 
    setLongitude, 
    address, 
    setAddress,
    distrito,
    ciudad,
    fetchAddress 
  };
};